// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.toast .toast-content {
    display: flex;
    align-items: center;
}

.toast-content .check {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    min-width: 35px;
    background-color: green !important;
    color: #fff;
    font-size: 20px;
    border-radius: 50%;
}

.toast-content .message {
    display: flex;
    flex-direction: column;
    margin: 0 20px;
}

.message.text {
    font-size: 16px;
    font-weight: 400;
    color: whitesmoke;
    font-family: Poppins, sans-serif
}

.message.text.text-1 {
    font-weight: 600;
    color: whitesmoke;
}

.toast .close {
    position: absolute;
    top: 10px;
    right: 15px;
    padding: 5px;
    cursor: pointer;
    opacity: 0.7;
}

.toast .close:hover {
    opacity: 1;
}

.toast .progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;

}
.progress{
    background-color: #0cbbda!important;
}

.toast .progress:before {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background-color: green !important;
}

.progress.active:before {
    animation: progress 3s linear forwards;
}
@keyframes progress {
    100% {
        right: 100%;
    }
}
.toast:not(.show){
    display: block !important;
}
.fa-xmark.close{
    color:red;
}
.fa.close:hover{
    color:red;
    border: none !important; /* Или border: 0; */

}
.hover_close:hover{
    color: red !important;

}
.toast .progress.red:before{
    background-color: red!important;
}
.toast-content .check.red{
    background-color: red!important;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Notification/Succses.css"],"names":[],"mappings":";;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;;AAEf;AACA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;IACT,uBAAuB,EAAE,mBAAmB;;AAEhD;AACA;IACI,qBAAqB;;AAEzB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;AACnC","sourcesContent":["\r\n\r\n\r\n.toast .toast-content {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.toast-content .check {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 35px;\r\n    min-width: 35px;\r\n    background-color: green !important;\r\n    color: #fff;\r\n    font-size: 20px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.toast-content .message {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 0 20px;\r\n}\r\n\r\n.message.text {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    color: whitesmoke;\r\n    font-family: Poppins, sans-serif\r\n}\r\n\r\n.message.text.text-1 {\r\n    font-weight: 600;\r\n    color: whitesmoke;\r\n}\r\n\r\n.toast .close {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 15px;\r\n    padding: 5px;\r\n    cursor: pointer;\r\n    opacity: 0.7;\r\n}\r\n\r\n.toast .close:hover {\r\n    opacity: 1;\r\n}\r\n\r\n.toast .progress {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    height: 3px;\r\n    width: 100%;\r\n\r\n}\r\n.progress{\r\n    background-color: #0cbbda!important;\r\n}\r\n\r\n.toast .progress:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: green !important;\r\n}\r\n\r\n.progress.active:before {\r\n    animation: progress 3s linear forwards;\r\n}\r\n@keyframes progress {\r\n    100% {\r\n        right: 100%;\r\n    }\r\n}\r\n.toast:not(.show){\r\n    display: block !important;\r\n}\r\n.fa-xmark.close{\r\n    color:red;\r\n}\r\n.fa.close:hover{\r\n    color:red;\r\n    border: none !important; /* Или border: 0; */\r\n\r\n}\r\n.hover_close:hover{\r\n    color: red !important;\r\n\r\n}\r\n.toast .progress.red:before{\r\n    background-color: red!important;\r\n}\r\n.toast-content .check.red{\r\n    background-color: red!important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
